import React from "react"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"

const FORM_2_URL =
  "/PAIA%20Form%202%20-%20Request%20for%20Access%20to%20Record.pdf"

const Container = styled.section`
  padding: 100px var(--gutter-s) 50px;
  @media (min-width: 768px) {
    padding: 150px var(--gutter-l) 50px;
  }
`

const HeadingContainer = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  color: var(--manatee);

  h1 {
    margin-bottom: 0.25rem;
  }
`

const Block = styled.div`
  margin-bottom: 2rem;
  h4,
  h5,
  p,
  td,
  th {
    color: var(--manatee);
    line-height: 150%;
  }
  h4 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }
  h5 {
    font-size: 0.95rem;
    margin: 1rem 0 0.5rem;
  }
  p {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }
  a {
    color: var(--havelock-blue);
    cursor: pointer;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0.5rem 0 1rem;
    font-size: 0.9rem;
  }
  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: 0.5rem;
    border: 1px solid var(--manatee);
  }
`

const Paia = () => {
  return (
    <Layout metaNavbar={true}>
      <SEO
        title="PAIA Manual"
        keywords={[
          `submitt`,
          `submitt app`,
          `paia`,
          `paia manual`,
          "medical claims",
          "doctors",
        ]}
      />
      <Container>
        <HeadingContainer>
          <h1>PAIA Manual</h1>
          <h5>Submitt Medical Accounts (Pty) Ltd</h5>
          <h5>Registration number 2013/008088/07, trading as SUBMITT</h5>
          <h5>
            Prepared in accordance with section 51 of the Promotion of Access to
            Information Act 2 of 2000
          </h5>
        </HeadingContainer>

        <Block>
          <h4>CONTENTS</h4>
          <p>1. Background to the Promotion of Access to Information Act</p>
          <p>2. SUBMITT</p>
          <p>3. Purpose of the PAIA Manual</p>
          <p>4. Contact Details of the Directors (section 51(1)(a))</p>
          <p>5. The Information Officer (section 51(1)(b))</p>
          <p>6. Guide on How to Use the Act</p>
          <p>7. The Latest Notice in Terms of Section 52(2) (if any)</p>
          <p>
            8. Records Available Only on Request to Access in Terms of the Act
            (section 51(1)(d))
          </p>
          <p>
            9. Records Available Without a Request to Access in Terms of the Act
          </p>
          <p>10. Records Available in Terms of Any Other Legislation</p>
          <p>
            11. Processing of Personal Information (Protection of Personal
            Information Act 4 of 2013)
          </p>
          <p>12. Request Procedure</p>
          <p>13. Refusal of Access to Records</p>
          <p>14. Remedies Available When SUBMITT Refuses a Request</p>
          <p>15. Access to Records Held by SUBMITT</p>
          <p>16. Fees</p>
          <p>17. Reproduction Fees</p>
          <p>18. Decision</p>
          <p>19. Availability and Updating of the PAIA Manual</p>
          <p>Annexure - Prescribed Request Form</p>
        </Block>

        <Block>
          <h4>1. BACKGROUND TO THE PROMOTION OF ACCESS TO INFORMATION ACT</h4>
          <p>
            1.1 The Promotion of Access to Information Act, No 2 of 2000 (“the
            Act”) was enacted on 3 February 2000, giving effect to the
            constitutional right in terms Section 32 of the Bill of Rights
            contained in the Constitution of the Republic of South Africa 108 of
            1996 (“the Constitution”) of access to any information held by the
            State and any information that is held by another person and that is
            required for the exercise or protection of any rights.
          </p>
          <p>
            1.2 In terms of section 51 of the Act, all private bodies are
            required to compile a manual (“PAIA Manual”). Section 52 deals
            separately with the voluntary disclosure of categories of records
            which are automatically available without a request.
          </p>
          <p>
            1.3 Where a request is made in terms of the Act, the body to whom
            the request is made is obliged to release the information, subject
            to applicable legislative and / or regulatory requirements, except
            where the Act expressly provides that the information may or must
            not be released. The Act sets out the relevant procedure to be
            adopted when requesting information from a Public or a Private Body.
          </p>
        </Block>

        <Block>
          <h4>2. SUBMITT</h4>
          <p>
            Submitt Medical Accounts (Pty) Ltd (“Submitt”) is a South African
            company that operates Submitt.App, a software application designed
            to assist medical practitioners, medical practices and medical
            billing bureaux with the administrative preparation and management
            of medical claims.
          </p>
          <p>
            Submitt.App provides functionality through which users may capture,
            process and manage patient and claims-related information, including
            medical aid information, billing information, ICD-10 codes and other
            information required in connection with medical claims. The
            Application may also facilitate the transmission of claims and
            claims-related information to a medical billing bureau selected by
            the relevant Customer.
          </p>
          <p>
            The Application incorporates automated information-extraction
            functionality using Amazon Textract, an Amazon Web Services (“AWS”)
            service, to assist in extracting specified information from images
            uploaded through the Application. Such information may include a
            medical aid name, medical aid membership number and a patient’s
            identification number. Information extracted through the automated
            functionality remains subject to human verification by the Customer
            or its authorised users.
          </p>
          <p>
            Submitt is a technology and administrative service provider and does
            not provide medical or clinical services. Submitt does not diagnose
            or treat patients, provide medical advice, determine appropriate
            medical treatment, or assume responsibility for the professional or
            clinical decisions of medical practitioners or the billing decisions
            of medical billing bureaux.
          </p>
          <p>
            In providing Submitt.App, Submitt may process Personal Information
            on behalf of its Customers. Customers generally determine the
            purposes for which Patient Information is processed and remain
            responsible for their obligations under applicable data protection
            legislation. To the extent that Submitt processes such information
            on behalf of a Customer, Submitt acts as an operator in accordance
            with the Customer’s lawful instructions.
          </p>
          <p>
            Submitt uses third-party technology and infrastructure providers in
            providing the Services, including AWS and Amazon Textract, and may
            facilitate integrations with third-party systems such as GoodX and
            medical billing bureaux.
          </p>
          <p>
            Submitt’s business therefore principally comprises the provision and
            operation of a software-as-a-service platform for the administration
            and processing of medical claims and related information, together
            with the technical and support services necessary to operate that
            platform.
          </p>
          <p>(Hereinafter “SUBMITT”)</p>
          <p>
            2.1 This PAIA Manual is relevant and is available to view in person
            at the premises of SUBMITT: Mooikloof Office Park, West Block, Block
            7, Cnr Atterbury Road and Jollify Main Road, Mooikloof, Pretoria,
            0081 as well as on its website:{" "}
            <a href="https://www.submitt.app">https://www.submitt.app</a>
          </p>
        </Block>

        <Block>
          <h4>3. PURPOSE OF THE PAIA MANUAL</h4>
          <p>
            3.1 This PAIA Manual is intended to ensure that SUBMITT complies
            with the Act and to foster a culture of transparency and
            accountability with SUBMITT by giving effect to the right to
            information that is required for the exercise or protection of any
            right and to actively promote a society in which the people of South
            Africa have effective access to information to enable them to
            exercise and protect their rights.
          </p>
          <p>
            3.2 In order to promote effective governance of private bodies, it
            is necessary to ensure that everyone is empowered and educated to
            understand their rights in terms of the Act in order for them to
            exercise their rights in relation to Public and Private Bodies.
          </p>
          <p>
            3.3 Section 9 of the Act recognizes that the right to access
            information cannot be unlimited and should be subject to justifiable
            limitations, including, but not limited to:
          </p>
          <p>
            3.3.1 Limitations aimed at the reasonable protection of privacy;
          </p>
          <p>3.3.2 Commercial confidentiality; and</p>
          <p>3.3.3 Effective, efficient and good governance; and</p>
          <p>
            3.3.4 In a manner which balances that right with any other rights,
            including such rights contained in the Bill of Rights in the
            Constitution.
          </p>
          <p>
            3.4 This PAIA Manual has been drafted in accordance with section 51
            of the Act and the Regulations made under it, having regard to the
            guidance published by the Information Regulator for private bodies.
          </p>
          <p>
            3.5 In addition, this PAIA Manual complies with the requirements of
            section 51 of the Act and recognises that under the Protection of
            Personal Information Act 4 of 2013, that the appointed Information
            Officer will be responsible to regulate compliance with the Act and
            its Regulations by Public and Private Bodies.
          </p>
        </Block>

        <Block>
          <h4>4. CONTACT DETAILS OF THE DIRECTORS (SECTION 51(1)(a))</h4>
          <table>
            <tbody>
              <tr>
                <th>Director(s):</th>
                <td>Joaquim Junior Henrique Martins</td>
              </tr>
              <tr>
                <th>Appointed Address:</th>
                <td>
                  Mooikloof Office Park, West Block, Block 7, Cnr Atterbury Road
                  and Jollify Main Road, Mooikloof, Pretoria, 0081.
                </td>
              </tr>
              <tr>
                <th>Postal Address:</th>
                <td>Same as above.</td>
              </tr>
              <tr>
                <th>Website:</th>
                <td>
                  <a href="https://www.submitt.app">https://www.submitt.app</a>
                </td>
              </tr>
            </tbody>
          </table>
        </Block>

        <Block>
          <h4>5. THE INFORMATION OFFICER (SECTION 51(1)(b))</h4>
          <p>
            5.1 The Act prescribes the appointment of an Information Officer for
            Public Bodies where such Information Officer is responsible to,
            inter alia, assess requests for access to information. The Head of a
            Private Body fulfills such a function in terms of Section 51.
            SUBMITT has opted to appoint an Information Officer to assess
            requests for access to information as well as to oversee its
            required functions in terms of the Act.
          </p>
          <p>
            5.2 The Information Officer appointed in terms of the Act also
            refers to the Information Officer as referred to in the Protection
            of Personal Information Act 4 of 2013. The Information Officer
            oversees the functions and responsibilities as required for in terms
            of both this Act as well as the duties and responsibilities in terms
            of Section 55 of the Protection of Personal Information Act 4 of
            2013 after registering with the Information Regulator.
          </p>
          <p>
            5.3 The Information Officer may appoint, where it is deemed
            necessary, Deputy Information Officers, as allowed in terms of
            Section 17 of the Act as well as Section 56 of the Protection of
            Personal Information Act 4 of 2013. This is in order to render
            SUBMITT as accessible as reasonably possible for requesters of its
            records and to ensure fulfillment of its obligations and
            responsibilities as prescribed in terms of Section 55 of the
            Protection of Personal Information Act 4 of 2013. All requests for
            information in terms of the Act must be addressed to the Information
            Officer.
          </p>
          <h5>Contact Details of the Information Officer</h5>
          <table>
            <tbody>
              <tr>
                <th>Information Officer:</th>
                <td>Joaquim Junior Henrique Martins</td>
              </tr>
              <tr>
                <th>Physical Address:</th>
                <td>
                  Mooikloof Office Park, West Block, Block 7, Cnr Atterbury Road
                  and Jollify Main Road, Mooikloof, Pretoria, 0081.
                </td>
              </tr>
              <tr>
                <th>Email:</th>
                <td>
                  <a href="mailto:info@submitt.app">info@submitt.app</a>
                </td>
              </tr>
              <tr>
                <th>Telephone:</th>
                <td>012-3441370</td>
              </tr>
            </tbody>
          </table>
        </Block>

        <Block>
          <h4>6. GUIDE ON HOW TO USE THE ACT</h4>
          <p>
            6.1 Section 10 of the Act provides for a guide to be compiled on how
            to use the Act. With effect from 30 June 2021 the functions of the
            South African Human Rights Commission under the Act were transferred
            to the Information Regulator, and the Guide is compiled and
            published by the Information Regulator.
          </p>
          <p>
            6.2 The Guide contains such information as may reasonably be
            required by a person who wishes to exercise any right contemplated
            in the Act, and accordingly it:
          </p>
          <p>
            6.2.1 contains information on understanding and how to use the Act;
          </p>
          <p>
            6.2.2 includes the objectives of the Act, particulars of every
            public and private body, the manner and form for requests, and the
            contents of the Regulations made under the Act; and
          </p>
          <p>6.2.3 is updated and published from time to time.</p>
          <p>
            6.3 The Guide is available in each of the official languages of the
            Republic of South Africa.
          </p>
          <p>
            6.4 The Guide may be obtained from the Information Regulator, and
            any enquiry regarding the Guide should be directed to the
            Information Regulator at the details below.
          </p>
          <table>
            <tbody>
              <tr>
                <th colSpan="2">Information Regulator (South Africa)</th>
              </tr>
              <tr>
                <th>Physical address:</th>
                <td>
                  Woodmead North Office Park, 54 Maxwell Drive, Woodmead,
                  Johannesburg, 2191
                </td>
              </tr>
              <tr>
                <th>Postal address:</th>
                <td>P.O. Box 31533, Braamfontein, Johannesburg, 2017</td>
              </tr>
              <tr>
                <th>Telephone:</th>
                <td>010 023 5200</td>
              </tr>
              <tr>
                <th>Toll free:</th>
                <td>0800 017 160</td>
              </tr>
              <tr>
                <th>General enquiries:</th>
                <td>
                  <a href="mailto:enquiries@inforegulator.org.za">
                    enquiries@inforegulator.org.za
                  </a>
                </td>
              </tr>
              <tr>
                <th>PAIA complaints:</th>
                <td>
                  <a href="mailto:PAIAComplaints@inforegulator.org.za">
                    PAIAComplaints@inforegulator.org.za
                  </a>
                </td>
              </tr>
              <tr>
                <th>Website:</th>
                <td>
                  <a href="https://www.inforegulator.org.za">
                    www.inforegulator.org.za
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </Block>

        <Block>
          <h4>7. THE LATEST NOTICE IN TERMS OF SECTION 52(2) (IF ANY)</h4>
          <p>
            At this stage no notice(s) has/have been published on the categories
            of records that are automatically available without a person having
            to request access in terms of the Act.
          </p>
        </Block>

        <Block>
          <h4>
            8. RECORDS AVAILABLE ONLY ON REQUEST TO ACCESS IN TERMS OF THE ACT
            (SECTION 51(1)(d))
          </h4>
          <p>
            8.1 This clause serves as a reference to the categories of
            information that SUBMITT holds. The information is classified and
            grouped according to records relating to the following subjects and
            categories:
          </p>
          <h5>8.2 Personnel Records</h5>
          <p>8.2.1 Personal records provided by personnel.</p>
          <p>8.2.2 Records provided by a third party relating to personnel.</p>
          <p>
            8.2.3 Conditions of employment and other personnel-related
            contractual and quasi-legal records.
          </p>
          <p>8.2.4 Internal evaluation records and other internal records.</p>
          <p>8.2.5 Correspondence relating to personnel.</p>
          <p>8.2.6 Training scheduled and material.</p>
          <p>
            “Personnel” refers to any person who works for, or provides services
            to or on behalf of SUBMITT, and receives or is entitled to receive
            remuneration and any other person who assists in carrying out or
            conducting the business of SUBMITT. This includes, without
            limitation, directors (executive and non-executive), all permanent,
            temporary and part-time staff, as well as contract workers.
          </p>
          <h5>8.3 Customer Related Records</h5>
          <p>
            8.3.1 Records provided by a customer to a third party acting for or
            on behalf of SUBMITT.
          </p>
          <p>8.3.2 Records provided by a third party.</p>
          <p>
            8.3.3 Records generated by or within SUBMITT relating to its
            customers, including transactional records.
          </p>
          <p>
            “Customer” refers to any natural or juristic entity that receives
            services from SUBMITT.
          </p>
          <h5>8.4 Private Body Records</h5>
          <p>8.4.1 Financial records</p>
          <p>8.4.2 Operational records</p>
          <p>8.4.3 Databases</p>
          <p>8.4.4 Information Technology</p>
          <p>8.4.5 Marketing records</p>
          <h5>8.5 Internal Correspondence</h5>
          <p>8.5.1 Product records</p>
          <p>8.5.2 Statutory records</p>
          <p>8.5.3 Internal Policies and Procedures</p>
          <p>8.5.4 Records held by officials of the institution</p>
          <p>
            These records include, but are not limited to, the records which
            pertain to SUBMITT’s own affairs.
          </p>
          <h5>8.6 Other Party Records</h5>
          <p>
            8.6.1 Personnel, customer or private body records which are held by
            another party, as opposed to the records held by SUBMITT itself.
          </p>
          <p>
            8.6.2 Records held by SUBMITT pertaining to other parties, including
            without limitation, financial records, correspondence, contractual
            records, records provided by the other party, and records third
            parties have provided about the contractors/suppliers.
          </p>
          <p>
            8.6.3 SUBMITT may possess records pertaining to other parties,
            including without limitation contractors, suppliers,
            subsidiary/holding/sister companies, joint venture companies, and
            service providers. Alternatively, such other parties may possess
            records that can be said to belong to SUBMITT.
          </p>
          <p>
            8.7 Note that the accessibility of the records may be subject to the
            grounds of refusal set out in this PAIA Manual. Amongst others,
            records deemed confidential on the part of a third party, will
            necessitate permission from the third party concerned, in addition
            to normal requirements, before SUBMITT will consider access.
          </p>
        </Block>

        <Block>
          <h4>
            9. RECORDS AVAILABLE WITHOUT A REQUEST TO ACCESS IN TERMS OF THE ACT
          </h4>
          <p>
            9.1 Records of a public nature, typically those disclosed on the
            SUBMITT’s website and in its various annual reports, may be accessed
            without the need to submit a formal application.
          </p>
          <p>
            9.2 Other non-confidential records, such as statutory records
            maintained at CIPC, may also be accessed without the need to submit
            a formal application, however, please note that an appointment to
            view such records will still have to be made with the Information
            Officer.
          </p>
        </Block>

        <Block>
          <h4>10. RECORDS AVAILABLE IN TERMS OF ANY OTHER LEGISLATION</h4>
          <p>
            10.1 Where applicable to its operations, SUBMITT also retains
            records and documents in terms of the legislation listed below.
            Unless disclosure is prohibited in terms of legislation,
            regulations, contractual agreement or otherwise, records that are
            required to be made available in terms of these Acts shall be made
            available for inspection by interested parties in terms of the
            requirements and conditions of the Act and applicable internal
            policies and procedures, should such interested parties be entitled
            to such information. A request to access must be done in accordance
            with the prescriptions of such Act.
          </p>
          <table>
            <thead>
              <tr>
                <th>Legislation</th>
                <th>Records held</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Companies Act 71 of 2008</td>
                <td>
                  Statutory records, registers, minutes, resolutions, annual
                  returns and annual financial statements
                </td>
              </tr>
              <tr>
                <td>
                  Income Tax Act 58 of 1962 and Tax Administration Act 28 of
                  2011
                </td>
                <td>
                  Tax returns, assessments, supporting records and employees’
                  tax records
                </td>
              </tr>
              <tr>
                <td>Value-Added Tax Act 89 of 1991</td>
                <td>VAT records, tax invoices and returns</td>
              </tr>
              <tr>
                <td>Basic Conditions of Employment Act 75 of 1997</td>
                <td>
                  Records of employees, remuneration, hours of work and leave
                </td>
              </tr>
              <tr>
                <td>Labour Relations Act 66 of 1995</td>
                <td>Employment and workplace records</td>
              </tr>
              <tr>
                <td>
                  Unemployment Insurance Act 63 of 2001 and Unemployment
                  Insurance Contributions Act 4 of 2002
                </td>
                <td>Records of employees and contributions</td>
              </tr>
              <tr>
                <td>
                  Compensation for Occupational Injuries and Diseases Act 130 of
                  1993
                </td>
                <td>Records of earnings and of any incident reported</td>
              </tr>
              <tr>
                <td>Skills Development Levies Act 9 of 1999</td>
                <td>Levy records and returns</td>
              </tr>
              <tr>
                <td>Protection of Personal Information Act 4 of 2013</td>
                <td>
                  Records relating to the processing of personal information,
                  operator arrangements and security compromises
                </td>
              </tr>
              <tr>
                <td>
                  Electronic Communications and Transactions Act 25 of 2002
                </td>
                <td>Records of data messages and electronic transactions</td>
              </tr>
              <tr>
                <td>Consumer Protection Act 68 of 2008</td>
                <td>
                  Records relating to transactions with consumers, where
                  applicable
                </td>
              </tr>
              <tr>
                <td>Occupational Health and Safety Act 85 of 1993</td>
                <td>Health and safety records</td>
              </tr>
            </tbody>
          </table>
          <p>
            10.2 It is further recorded that the accessibility of documents and
            records may be subject to the grounds of refusal set out in this
            PAIA Manual.
          </p>
        </Block>

        <Block>
          <h4>
            11. PROCESSING OF PERSONAL INFORMATION (PROTECTION OF PERSONAL
            INFORMATION ACT 4 OF 2013)
          </h4>
          <p>
            11.1 In addition to the requirements of the Act, this PAIA Manual
            records the following particulars of the processing of personal
            information by SUBMITT, as contemplated in the Protection of
            Personal Information Act 4 of 2013 (“POPIA”).
          </p>
          <p>
            11.2 SUBMITT processes personal information for the following
            purposes:
          </p>
          <p>
            11.2.1 the provision, operation, administration, security and
            support of Submitt.App;
          </p>
          <p>
            11.2.2 the capture, extraction and processing of information
            required for the preparation, management and submission of medical
            claims;
          </p>
          <p>
            11.2.3 the administration of Customer accounts, subscriptions and
            billing;
          </p>
          <p>11.2.4 communication with Customers and their authorised users;</p>
          <p>
            11.2.5 the detection, prevention and investigation of fraud, misuse
            and security incidents; and
          </p>
          <p>11.2.6 compliance with legal and regulatory obligations.</p>
          <p>
            11.3 The categories of data subjects, and of the personal
            information relating to them, are:
          </p>
          <p>
            11.3.1 Customers and their authorised users: name, contact details,
            practice number, login credentials and account and subscription
            information;
          </p>
          <p>
            11.3.2 patients of Customers: name, identity number, medical aid
            name and membership number, billing and ICD-10 codes and other
            information appearing on the documentation uploaded through the
            Application;
          </p>
          <p>
            11.3.3 personnel of SUBMITT: the records described in clause 8.2;
            and
          </p>
          <p>
            11.3.4 suppliers and service providers: contact and contractual
            details.
          </p>
          <p>
            11.4 Personal information may be supplied to the following
            categories of recipients:
          </p>
          <p>
            11.4.1 Amazon Web Services, including Amazon Textract, in respect of
            hosting and the automated extraction of information from uploaded
            images;
          </p>
          <p>
            11.4.2 Teamgeek, in respect of the development, operation and
            support of the Application and the administration of the hosting
            environment;
          </p>
          <p>
            11.4.3 GoodX, in respect of the integration through which claims are
            created;
          </p>
          <p>
            11.4.4 the medical billing bureau nominated by the relevant
            Customer;
          </p>
          <p>
            11.4.5 Stripe, in respect of subscription payments; Sentry, in
            respect of error and diagnostic reporting; AWS Amplify, in respect
            of usage analytics; and Expo, in respect of the distribution of
            application updates;
          </p>
          <p>
            11.4.6 SUBMITT’s professional advisors, auditors and insurers; and
          </p>
          <p>
            11.4.7 a court, regulator or other authority, where disclosure is
            required by law.
          </p>
          <p>
            11.5 Personal information is processed and stored outside the
            Republic of South Africa. In particular, SUBMITT uses Amazon Web
            Services infrastructure in the European Union (eu-west-1). Where
            personal information is transferred outside the Republic, SUBMITT
            takes reasonable steps to ensure that the transfer and subsequent
            processing are undertaken in accordance with section 72 of POPIA.
          </p>
          <p>
            11.6 SUBMITT employs appropriate technical and organisational
            measures to secure the integrity and confidentiality of personal
            information in its possession or under its control, including access
            controls, authentication measures, system monitoring, cloud
            infrastructure security, and backup and recovery measures. Every
            person who has access to uploaded documents or patient information
            is bound by a written undertaking of confidentiality, and operators
            are engaged under written agreements as contemplated in section 21
            of POPIA.
          </p>
          <p>
            11.7 In respect of patient information processed through the
            Application, SUBMITT acts as an operator on behalf of the Customer,
            which remains the responsible party. SUBMITT is the responsible
            party in respect of the personal information it processes for its
            own purposes, including Customer account, subscription and personnel
            information.
          </p>
          <p>
            11.8 In addition to the recipients referred to in clause 11.4,
            SUBMITT uses Google Cloud Platform, specifically Google Cloud Run,
            hosted in the africa-south1 region, in respect of certain
            application-hosting and data-processing infrastructure used to
            provide the Services.
          </p>
          <p>
            11.9 The Application processes data received from authorised
            requests and does not intentionally persist or permanently store
            such data within the application container or the Google Cloud Run
            environment referred to in clause 11.8. That environment is used
            primarily for processing and transmitting data between authorised
            systems. Any data temporarily held in application memory during
            processing is not intended to constitute permanent data storage.
          </p>
        </Block>

        <Block>
          <h4>12. REQUEST PROCEDURE</h4>
          <h5>12.1 Procedural Requirements</h5>
          <p>
            12.1.1 The requester must comply with all the procedural
            requirements contained in the Act relating to the request for access
            to a record.
          </p>
          <p>
            12.1.2 The requester must complete the prescribed form enclosed
            herewith, and submit same as well as payment of a request fee and a
            deposit (if applicable) to the Information Officer or the Deputy
            Information Officer at the postal or physical address, fax number or
            electronic mail address as noted in clause 5 above.
          </p>
          <p>
            12.1.3 The prescribed form must be filled in with sufficient
            information to enable the Information Officer to identify:
          </p>
          <p>12.1.3.1 the record or records requested; and</p>
          <p>12.1.3.2 the identity of the requester.</p>
          <p>
            12.1.4 The requester should indicate which form of access is
            required and specify a postal address or fax number of the requester
            in the Republic;
          </p>
          <p>
            12.1.5 The requester must state that he/she requires the information
            in order to exercise or protect a right, and clearly state what the
            nature of the right is so to be exercised or protected. The
            requester must clearly specify why the record is necessary to
            exercise or protect such a right (Section 53(2)(d)).
          </p>
          <p>
            12.1.6 SUBMITT will process the request within 30 (thirty) days,
            unless the requester has stated special reasons to the satisfaction
            of the Information Officer that circumstances dictate that the above
            time periods not be complied with.
          </p>
          <p>
            12.1.7 The requester shall be advised whether access is granted or
            denied in writing. If, in addition, the requester requires the
            reasons for the decision in any other manner, the requester will be
            obliged to state which manner and the particulars required.
          </p>
          <p>
            12.1.8 If a request is made on behalf of another person, then the
            requester must submit proof of the capacity in which the requester
            is making the request to the reasonable satisfaction of the
            Information Officer (Section 53(2)(f)).
          </p>
          <p>
            12.1.9 If an individual is unable to complete the prescribed form
            because of illiteracy or disability, such a person may make a
            request orally.
          </p>
          <p>
            12.1.10 The requester must pay the prescribed fee, before any
            further processing can take place.
          </p>
          <p>
            12.1.11 All information as listed in clause 12.1 should be provided,
            failing which the process will be delayed until the required
            information is provided. The prescribed time periods will not
            commence until the requester has furnished all the necessary and
            required information. The Information officer shall sever a record,
            if possible, and grant only access to the portion requested and
            which is not prohibited from being disclosed.
          </p>
        </Block>

        <Block>
          <h4>13. REFUSAL OF ACCESS TO RECORDS</h4>
          <p>
            A Private Body such as SUBMITT is entitled to refuse a request for
            information.
          </p>
          <p>
            13.1 The main grounds for SUBMITT to refuse a request for
            information relates to the:
          </p>
          <p>
            13.1.1 mandatory protection of the privacy of a third party who is a
            natural person or a deceased person (Section 63) or a juristic
            person, as included in the Protection of Personal Information Act 4
            of 2013, which would involve the unreasonable disclosure of personal
            information of that natural or juristic person;
          </p>
          <p>
            13.1.2 mandatory protection of personal information and for
            disclosure of any personal information to, in addition to any other
            legislative, regulatory or contractual agreements, comply with the
            provisions of the Protection of Personal Information Act 4 of 2013;
          </p>
          <p>
            13.1.3 mandatory protection of the commercial information of a third
            party (Section 64), if the record contains:
          </p>
          <p>13.1.3.1 trade secrets of the third party;</p>
          <p>
            13.1.3.2 financial, commercial, scientific or technical information
            which disclosure could likely cause harm to the financial or
            commercial interests of the third party;
          </p>
          <p>
            13.1.3.3 information disclosed in confidence by a third party to
            SUBMITT, if the disclosure could put that third party at a
            disadvantage in negotiations or commercial competition;
          </p>
          <p>
            13.1.4 mandatory protection of confidential information of third
            parties (Section 65) if it is protected in terms of any agreement;
          </p>
          <p>
            13.1.5 mandatory protection of the safety of individuals and the
            protection of property (Section 66);
          </p>
          <p>
            13.1.6 mandatory protection of records which would be regarded as
            privileged in legal proceedings (Section 67).
          </p>
          <p>
            13.2 The commercial activities (Section 68) of a Private Body, such
            as SUBMITT, which may include:
          </p>
          <p>13.2.1 trade secrets of SUBMITT;</p>
          <p>
            13.2.2 financial, commercial, scientific or technical information
            which disclosure could likely cause harm to the financial or
            commercial interests of SUBMITT;
          </p>
          <p>
            13.2.3 information which, if disclosed could put SUBMITT at a
            disadvantage in negotiations or commercial competition;
          </p>
          <p>
            13.2.4 a computer program which is owned by SUBMITT, and which is
            protected by copyright;
          </p>
          <p>
            13.2.5 the research information (Section 69) of SUBMITT or a third
            party, if its disclosure would disclose the identity of SUBMITT, the
            researcher or the subject matter of the research and would place the
            research at a serious disadvantage.
          </p>
          <p>
            13.3 Requests for information that are clearly frivolous or
            vexatious, or which involve an unreasonable diversion of resources
            shall be refused.
          </p>
          <p>
            13.4 All requests for information will be assessed on their own
            merits and in accordance with the applicable legal principles and
            legislation.
          </p>
          <p>
            13.5 If a requested record cannot be found or if the record does not
            exist, the Information Officer shall, by way of an affidavit or
            affirmation, notify the requester that it is not possible to give
            access to the requested record. Such a notice will be regarded as a
            decision to refuse a request for access to the record concerned for
            the purpose of the Act. If the record should later be found, the
            requester shall be given access to the record in the manner
            stipulated by the requester in the prescribed form, unless the
            Information Officer refuses access to such record.
          </p>
        </Block>

        <Block>
          <h4>14. REMEDIES AVAILABLE WHEN SUBMITT REFUSES A REQUEST</h4>
          <h5>14.1 Internal Remedies</h5>
          <p>
            SUBMITT does not have an internal appeal procedure. The decision
            made by the Information Officer is final. Requesters will have to
            exercise such external remedies at their disposal if the request for
            information is refused, and the requestor is not satisfied with the
            answer supplied by the Information Officer.
          </p>
          <h5>14.2 External Remedies</h5>
          <p>
            14.2.1 A requester or third party who is dissatisfied with a
            decision of the Information Officer may lodge a complaint with the
            Information Regulator in terms of Part 4 of Chapter 1 of the Act. A
            complaint must be lodged in the form, and within the period,
            prescribed by the Act and the Regulations made under it. The contact
            details of the Information Regulator are set out in clause 6.
          </p>
          <p>
            14.2.2 A requester or third party may also apply to a court for
            appropriate relief, as provided in the Act.
          </p>
          <p>
            14.2.3 A requestor that is dissatisfied with the Information
            Officer’s decision to grant a request for Information, may within 30
            (thirty) days of the notification of the decision, apply to a Court
            for relief.
          </p>
          <p>
            14.2.4 A third party dissatisfied with the Information Officer’s
            decision to grant a request for information, may within 30 (thirty)
            days of notification of the decision, apply to a Court for relief.
          </p>
          <p>
            For purposes of the Act, the Courts that have jurisdiction over
            these applications are the Constitutional Court, the High Court or
            another Court of similar status and a Magistrate’s Court designated
            by the Minister of Justice and Constitutional Development and which
            is presided over by a designated Magistrate.
          </p>
        </Block>

        <Block>
          <h4>15. ACCESS TO RECORDS HELD BY SUBMITT</h4>
          <h5>15.1 Prerequisites for Access by Personal/Other Requester</h5>
          <p>
            15.1.1 Records held by SUBMITT may be accessed by requests only once
            the prerequisite requirements for access have been met.
          </p>
          <p>
            15.1.2 A requester is any person making a request for access to a
            record of SUBMITT. There are two types of requesters:
          </p>
          <p>15.1.3 Personal Requester</p>
          <p>
            15.1.3.1 A personal requester is a requester who is seeking access
            to a record containing personal information about the requester.
          </p>
          <p>
            15.1.3.2 SUBMITT will voluntarily provide the requested information,
            or give access to any record with regard to the requester’s personal
            information. The prescribed fee for reproduction of the information
            requested will be charged.
          </p>
          <p>15.1.4 Other Requester</p>
          <p>
            15.1.4.1 This requester (other than a personal requester) is
            entitled to request access to information on third parties.
          </p>
          <p>
            15.1.4.2 In considering such a request, SUBMITT will adhere to the
            provisions of the Act. Section 71 requires that the Information
            Officer take all reasonable steps to inform a third party to whom
            the request record relates of the request, informing him/her that
            he/she may make a written or oral representation to the Information
            Officer why the request should be refused or, where required, give
            written consent for the disclosure of the information.
          </p>
          <p>
            SUBMITT is not obliged to voluntarily grant access to such records.
            The requester must fulfil the prerequisite requirements, in
            accordance with the requirements of the Act and as stipulated in
            Chapter 5; Part 3, including the payment of a request and access
            fee.
          </p>
        </Block>

        <Block>
          <h4>16. FEES</h4>
          <h5>16.1 Fees Provided by the Act</h5>
          <p>16.1.1 The Act provides for two types of fees, namely:</p>
          <p>
            16.1.1.1 A request fee, which is a form of administration fee to be
            paid by all requesters except personal requesters, before the
            request is considered. The request fee is not refundable; and
          </p>
          <p>
            16.1.1.2 An access fee, which is paid by all requesters in the event
            that a request for access is granted. This fee is inclusive of costs
            involved by the Private Body in obtaining and preparing a record for
            delivery to the requester.
          </p>
          <p>
            16.1.2 When the request is received by the Information Officer, such
            officer shall by notice require the requester, other than a personal
            requester, to pay the prescribed request fee, before further
            processing of the request (Section 54(1)).
          </p>
          <p>
            16.1.3 If the search for the record has been made and the
            preparation of the record for disclosure, including arrangement to
            make it available in the requested form, requires more than the
            hours prescribed in the regulations for this purpose, the
            Information Officer shall notify the requester to pay, as a deposit,
            the prescribed portion of the access fee which would be payable if
            the request is granted.
          </p>
          <p>
            16.1.4 The Information Officer shall withhold a record until the
            requester has paid fees as indicated below.
          </p>
          <p>
            16.1.5 A requester whose request for access to a record has been
            granted, must pay an access fee that is calculated to include, where
            applicable, the request fee, the process fee for reproduction and
            for search and preparation, and for any time reasonably required in
            excess of the prescribed hours to search for and prepare the record
            for disclosure including making arrangements to make it available in
            the request form.
          </p>
          <p>
            16.1.6 If a deposit has been paid in respect of a request for
            access, which is refused, then the Information officer concerned
            must repay the deposit to the requester.
          </p>
        </Block>

        <Block>
          <h4>17. REPRODUCTION FEES</h4>
          <p>
            17.1 The fees payable under the Act are those prescribed in the
            Regulations made under the Act, as amended from time to time. The
            amounts set out below are those prescribed in Annexure B to the
            Regulations Relating to the Promotion of Access to Information,
            2021, published under Government Notice R.757 in Government Gazette
            45057 of 27 August 2021. Where the prescribed fees are amended, the
            amended fees apply and this PAIA Manual will be updated accordingly.
          </p>
          <p>
            17.2 Where SUBMITT has voluntarily provided the Minister with a list
            of categories of records that will automatically be made available
            to any person requesting access thereto, the only charge that may be
            levied for obtaining such records is a fee for reproduction of the
            record in question.
          </p>
          <table>
            <thead>
              <tr>
                <th>Reproduction</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  A photocopy or printed copy of an A4 size page, or part
                  thereof, in black and white
                </td>
                <td>R2.00</td>
              </tr>
              <tr>
                <td>A copy on a flash drive provided by the requester</td>
                <td>R40.00</td>
              </tr>
              <tr>
                <td>A copy on a compact disc provided by the requester</td>
                <td>R40.00</td>
              </tr>
              <tr>
                <td>A copy on a compact disc provided by SUBMITT</td>
                <td>R60.00</td>
              </tr>
              <tr>
                <td>A transcription of visual images, per A4 size page</td>
                <td>
                  To be outsourced. The fee is the amount of the quotation
                  obtained.
                </td>
              </tr>
              <tr>
                <td>A copy of visual images</td>
                <td>
                  To be outsourced. The fee is the amount of the quotation
                  obtained.
                </td>
              </tr>
              <tr>
                <td>A transcription of an audio record, per A4 size page</td>
                <td>R24.00</td>
              </tr>
              <tr>
                <td>
                  A copy of an audio record on a flash drive provided by the
                  requester
                </td>
                <td>R40.00</td>
              </tr>
              <tr>
                <td>
                  A copy of an audio record on a compact disc provided by the
                  requester
                </td>
                <td>R40.00</td>
              </tr>
              <tr>
                <td>
                  A copy of an audio record on a compact disc provided by
                  SUBMITT
                </td>
                <td>R60.00</td>
              </tr>
            </tbody>
          </table>
          <h5>17.3 Request Fees</h5>
          <p>
            A requester who is not a personal requester must pay a request fee
            of R140.00 before the request is further processed. The request fee
            is not refundable.
          </p>
          <h5>17.4 Access Fees</h5>
          <p>
            17.4.1 An access fee is payable in all instances where a request for
            access to information is granted, except in those instances where
            payment of an access fee is specifically excluded in terms of the
            Act or an exclusion is determined by the Minister in terms of
            section 54(8).
          </p>
          <p>
            17.4.2 The access fee comprises the reproduction fees set out above,
            together with the following:
          </p>
          <table>
            <thead>
              <tr>
                <th>Access</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  To search for and prepare the record for disclosure, for each
                  hour or part of an hour reasonably required for the search and
                  preparation, excluding the first hour
                </td>
                <td>R145.00, but not exceeding R435.00 in total</td>
              </tr>
              <tr>
                <td>
                  Where a copy of a record must be posted, or transmitted by
                  e-mail or other electronic means
                </td>
                <td>The actual cost of the postage or transmission</td>
              </tr>
            </tbody>
          </table>
          <h5>17.5 Deposits</h5>
          <p>
            17.5.1 Where the Information Officer, on receipt of a request for
            access to information held on a person other than the requester, is
            of the opinion that the search for and preparation of the record for
            disclosure will take more than 6 (six) hours, a deposit is payable
            by the requester.
          </p>
          <p>
            17.5.2 The amount of the deposit is equal to 1/3 (one third) of the
            amount of the applicable access fees.
          </p>
          <p>
            17.5.3 If a deposit has been paid in respect of a request which is
            refused, the Information Officer must repay the deposit to the
            requester.
          </p>
          <h5>17.6 Payment</h5>
          <p>
            17.6.1 All fees must be paid into a bank account nominated in
            writing by SUBMITT, and proof of payment must be sent to the
            Information Officer at the details set out in clause 5, together
            with the request form and any supporting documents.
          </p>
          <p>
            17.7 All fees are subject to amendment as provided for in the Act,
            and such amendments may not always be immediately reflected in this
            PAIA Manual. A requester will be informed of the fees payable before
            any payment is made.
          </p>
        </Block>

        <Block>
          <h4>18. DECISION</h4>
          <h5>18.1 Time Allowed to Institution</h5>
          <p>
            18.1.1 SUBMITT will within 30 (thirty) days of receipt of the
            request, decide whether to grant or decline the request and give
            notice with reasons (if required) to that effect.
          </p>
          <p>
            18.1.2 The 30 (thirty) day period within which SUBMITT has to decide
            whether to grant or refuse the request, may be extended for a
            further period of not more than 30 (thirty) days if the request is
            for a large number of information, or the request requires a search
            for information held at another office and the information cannot
            reasonably be obtained within the original 30 (thirty) day period.
          </p>
          <p>
            18.1.3 SUBMITT will notify the requester in writing should an
            extension be sought.
          </p>
        </Block>

        <Block>
          <h4>19. AVAILABILITY AND UPDATING OF THE PAIA MANUAL</h4>
          <h5>19.1 Availability</h5>
          <p>
            19.1.1 This PAIA Manual is made available in terms of section 51 of
            the Act and the Regulations Relating to the Promotion of Access to
            Information, 2021, published under Government Notice R.757 in
            Government Gazette 45057 of 27 August 2021, which replaced the
            Regulations of 2002. SUBMITT will update this PAIA Manual at such
            intervals as may be necessary.
          </p>
          <p>
            19.1.2 This PAIA Manual of SUBMITT is available to view at its
            premises as aforesaid as well as on its website{" "}
            <a href="https://www.submitt.app">https://www.submitt.app</a>
          </p>
        </Block>

        <Block>
          <h4>ANNEXURE - PRESCRIBED REQUEST FORM</h4>
          <p>
            A request for access to a record of SUBMITT must be made on the form
            prescribed by the Regulations made under the Act.
          </p>
          <p>
            The prescribed form is Form 2, Request for Access to Record,
            prescribed by regulation 7 of the Regulations Relating to the
            Promotion of Access to Information, 2021, published under Government
            Notice R.757 in Government Gazette 45057 of 27 August 2021. Those
            Regulations replaced the Regulations of 2002, and the earlier Form C
            is no longer the prescribed form.
          </p>
          <p>
            A request must be made in a form that corresponds substantially with
            Form 2, and must be delivered to the Information Officer at the
            address, or sent to the e-mail address, set out in clause 5.
          </p>
          <p>
            <a href={FORM_2_URL} download>
              Download Form 2 - Request for Access to Record (PDF)
            </a>
          </p>
          <p>
            Form 2, and the Guide compiled by the Information Regulator, may
            also be obtained from the Information Regulator at{" "}
            <a href="https://www.inforegulator.org.za">
              www.inforegulator.org.za
            </a>
            , or from SUBMITT on request to the Information Officer.
          </p>
        </Block>
      </Container>
    </Layout>
  )
}

export default Paia
